import { render } from "./PerformerIconBar.vue?vue&type=template&id=77abf48a&ts=true"
import script from "./PerformerIconBar.vue?vue&type=script&lang=ts"
export * from "./PerformerIconBar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__